import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, Router } from "@angular/router";
import { forkJoin, Observable } from "rxjs";
import { map } from "rxjs/operators";

import { LorenAssetResolverConstant } from "./constants/loren-asset-resolver.constant";
import { LorenAsset } from "../interfaces/loren-asset.interface";
import { LorenAssetProperty } from "../interfaces/loren-asset-property.interface";
import { BaseEntityResolver } from "../../../shared/resolvers/loren-base-entity-resolver/base-entity.resolver";
import { LorenAssetService } from "../services/loren-asset-service/loren-asset.service";
import { LorenAssetTypeService } from "../services/loren-asset-type-service/loren-asset-type.service";
import { LorenAssetPropertiesService } from "../services/loren-asset-properties-service/loren-asset-properties.service";
import { LorenAssetUtilsService } from "../services/loren-asset-utils-service/loren-asset-utils.service";
import { LorenErrorHandlingService } from "../../../shared/services/loren-error-handling-service/loren-error-handling-service.service";

@Injectable()
export class LorenAssetResolver extends BaseEntityResolver<LorenAsset> {
  protected service: LorenAssetService;
  private lorenAssetTypeService = inject(LorenAssetTypeService);
  private propertiesService = inject(LorenAssetPropertiesService);
  protected router: Router;
  protected errorHandlingService: LorenErrorHandlingService;

  constructor() {
    const service = inject(LorenAssetService);
    const router = inject(Router);
    const errorHandlingService = inject(LorenErrorHandlingService);

    super(
      service,
      LorenAssetResolverConstant.ASSET_ID,
      router,
      errorHandlingService
    );
  
    this.service = service;
    this.router = router;
    this.errorHandlingService = errorHandlingService;
  }

  resolve(route: ActivatedRouteSnapshot): Observable<LorenAsset> {
    const id = route.params[this.resolveName];

    return forkJoin([
      this.service.get(id),
      this.lorenAssetTypeService.query(),
      this.propertiesService.query(),
    ]).pipe(
      map((res) => {
        const asset: LorenAsset = res[0];
        const properties: LorenAssetProperty[] = res[2].items;

        const typeProperties = LorenAssetUtilsService.getAssetTypeProperties(
          res[1].items,
          asset
        );
        LorenAssetUtilsService.populateAssetProperties(
          properties,
          typeProperties,
          asset
        );

        return asset;
      })
    );
  }
}
